import { useCallback, useEffect, useState } from 'react';
import useLocalStorage from '@alltrails/local-storage/useLocalStorage';

const localStorageKey = 'review-summary-feedback-provided';

const useFeedbackProvided = (key: string, reviewSummary?: string) => {
  const { getValue, setValue } = useLocalStorage<Record<string, string>>(localStorageKey);
  const [isFeedbackProvided, setIsFeedbackProvided] = useState<boolean | null>(null);

  const provideFeedback = useCallback(() => {
    if (!reviewSummary) {
      return;
    }

    const value = getValue();
    if (value) {
      setValue({ ...value, [key]: reviewSummary });
    } else {
      setValue({ [key]: reviewSummary });
    }
  }, [getValue, setValue, key, reviewSummary]);

  useEffect(() => {
    setIsFeedbackProvided(reviewSummary ? getValue()?.[key] === reviewSummary : false);
  }, [getValue, key, reviewSummary]);

  return { isFeedbackProvided, provideFeedback };
};

export default useFeedbackProvided;
